import React from "react";

export default function IssueList({ issues, selectedFixes, toggleAccept, loading }) {
  if (loading) return <p>Checking for issues...</p>;
  if (!issues || issues.length === 0) return <p>No issues found.</p>;

  return (
    <div style={{ maxHeight: 350, overflowY: "auto" }}>
      {issues.map((issue, index) => {
        const key = `${issue.row}-${issue.col}`;
        const selected = !!selectedFixes[key];

        return (
          <div
            key={index}
            style={{
              padding: "12px",
              marginBottom: "10px",
              borderRadius: "8px",
              background: "#fdfdfd",
              borderLeft: "5px solid #FF7043",
              boxShadow: "0 2px 5px rgba(0,0,0,0.08)"
            }}
          >
            <strong style={{ color: "#D84315" }}>
              {issue.issue.toUpperCase()}
            </strong>{" "}
            — <span style={{ color: "#777" }}>({issue.confidence})</span>
            <br />

            <div style={{ marginTop: 5, lineHeight: 1.6 }}>
              <b>Row:</b> {issue.row} &nbsp; | &nbsp; <b>Column:</b> {issue.col}
              <br />

              <b>Original:</b>{" "}
              <code style={{ color: "red" }}>{issue.original}</code>
              <br />

              <b>AI Suggestion:</b>{" "}
              <code style={{ color: "purple", fontWeight: "bold" }}>
                {issue.ai_suggestion}
              </code>
              <br />

              <b>Rule Suggestion:</b>{" "}
              <code style={{ color: "green" }}>
                {issue.suggestion || "(none)"}
              </code>
            </div>

            <button
              onClick={() => toggleAccept(issue)}
              style={{
                marginTop: 10,
                background: selected ? "#388E3C" : "#9e9e9e",
                color: "white",
                padding: "6px 12px",
                borderRadius: "5px",
                border: "none",
                cursor: "pointer",
              }}
            >
              {selected ? "Selected ✔" : "Accept"}
            </button>
          </div>
        );
      })}
    </div>
  );
}
